/**
 *  Games launcher
 */

define(function(require, exports, module) {
    'use strict';
    const _ = require('underscore');
    const config = require('config');
    const i18n = require('i18n');
    const user = require('user');
    const url = require('util/url.util');
    const storage = require('util/storage.util');
    const Launcher = require('modules/launcher/launcher');
    const historyUtil = require('util/history.util');
    const Base3rdPartyPlatform = require('modules/launcher/platforms/base.3rdParty.platform');

    module.exports = _.extend({}, Launcher, {

       launchGame: function(gameCode, mode, queryString, options) {
            const { ageVerificationStatus } = user.get('userDetails');
            const isDataVerificationStatusNeeded = config.get('enableDataVerificationStatusCheck')
                && ['failed', 'review', 'unknown'].includes(ageVerificationStatus);

            // disable Game launch for Admin
            if (user.isAdmin()) {
                window.Playtech.API.popup.showPopup({
                    title: i18n.t('playtech.mobile.system.launcher.gameLaunchPopup.title'),
                    content: i18n.t('playtech.mobile.system.launcher.gameLaunchPopup.content')
                });

                return;
            }

            if (Playtech.API.htcmd.isEnabled) {
                Playtech.API.htcmd.launchgame({ code: gameCode, mode });
                return;
            }

            if (isDataVerificationStatusNeeded) {
                console.warn('Game playing is disabled because of "DataVerificationStatus" verification is needed');

                // in case loginPage is configured
                Base3rdPartyPlatform.navigateFromLaunchGamePath();

                return;
            }

            // continue register for fast registered players
            if (user.isFastRegistered()) {
                window.Playtech.API.popup.closePopups();

                return user.continueRegistration(true,
                    {
                        code: gameCode,
                        mode: mode,
                        queryString: queryString,
                        options: options
                    });
            }

            this.removeCommand(); // remove saved command id from previous game session

            const game = this._getGame(gameCode);

            if (!game) {
                Base3rdPartyPlatform.navigateFromLaunchGamePath();

                return;
            }

            // Real mode by default
            mode = mode !== undefined ? mode : 1;

            // If we try to open demo mode need to check if it's available
            if (!mode || this.originalGameMode === 0) {
                this.originalGameMode = mode;

                var gameModesMap = {
                    guest: Number(user.isLoggedIn()),
                    user: Number(!user.isLoggedIn()),
                    both: 0,
                    unavailable: 1
                };

                mode = gameModesMap[game.demoModeSupport];
            }

            if (mode && !user.isLoggedIn()) {
                const { prevPath } = historyUtil?.state?.state || {};
                const { pathname, search } = window.location;
                const isGameLaunchPath = url.isLaunchGamePath(pathname, true);
                const newBackURLWithSearch = `${pathname}${search}`;
                const newPrevPathWithSearch = `${prevPath || '/'}${search}`;

                /* TotalCasino changes */
                if (config.get('loginPage')) {
                    storage.session.setItem('gamesPageUrl', url.getCleanUrl(newBackURLWithSearch));
                    storage.session.setItem('backPageUrl', url.getCleanUrl(isGameLaunchPath ? newPrevPathWithSearch : newBackURLWithSearch));
                }
                /* TotalCasino changes */

                // Open login popup for guest
                Playtech.API.auth.showLogin({
                    afterLoginUrl: '/igaming/' + gameCode,
                    onLogin: () => this._handleSuccessLogin(gameCode, mode, queryString, options)
                });

                return;
            }

            window.Playtech.API.popup.closePopups('gameLaunch');

            this.originalGameMode = null;

            return this.launchWithLimitsVerification(gameCode, mode, queryString, options);
        }
    });
});
